import { IEndereco } from "../Model/Endereco";
import axios from 'axios';
import useFormatter from "@hooks/useFormatter";
import React from "react";

export default function useCepService () {
    const formatter = useFormatter();

    const get = React.useCallback(async (cep: string) : Promise<Partial<IEndereco> | null> => {
        const cepOnlyNumbers = formatter.extractNumbers(cep);
        const url = `https://viacep.com.br/ws/${cepOnlyNumbers}/json/`;

        return new Promise<Partial<IEndereco> | null>(async (resolve, reject) => {
            const response = await axios.create().get(url);

            if (response && response.data && response.data["uf"]) {
                resolve({
                    endereco: response.data["logradouro"],
                    bairro: response.data["bairro"],
                    cidade: response.data["localidade"],
                    uf: response.data["uf"],
                    cep: cep,
                });
            }
    
            reject(response);
        });
    }, [formatter]);

    return React.useMemo(() => ({
        get
    }), [get])
}